import React, { useEffect, useState } from 'react';
import { isIosStandaloneCapable, isStandalonePwa } from '../utils/pwaUtils';
import { usePwaMobileUi } from '../hooks/usePwaMobileUi';
import './PWAInstallPrompt.css';

function PWAInstallPrompt() {
  const showPwaUi = usePwaMobileUi();
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(() =>
    sessionStorage.getItem('pwa-install-dismissed') === '1'
  );
  const [showIosHint, setShowIosHint] = useState(false);

  useEffect(() => {
    if (isStandalonePwa()) {
      return undefined;
    }

    const handleBeforeInstall = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstall);
    return () => window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
  }, []);

  const dismiss = () => {
    sessionStorage.setItem('pwa-install-dismissed', '1');
    setDismissed(true);
    setShowIosHint(false);
  };

  const handleInstall = async () => {
    if (!deferredPrompt) {
      return;
    }
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    dismiss();
  };

  if (!showPwaUi || dismissed || isStandalonePwa()) {
    return null;
  }

  const showAndroid = Boolean(deferredPrompt);
  const showIos = isIosStandaloneCapable();

  if (!showAndroid && !showIos) {
    return null;
  }

  return (
    <div className="pwa-install-banner" role="region" aria-label="Install app">
      <div className="pwa-install-banner__content">
        <strong>Install Project</strong>
        <p>
          Add to your home screen for quick access to Project List, Dashboard, and Production
          Performance in the field.
        </p>
        {showIos && showIosHint && (
          <p className="pwa-install-banner__ios-steps">
            Tap <span>Share</span> → <span>Add to Home Screen</span>
          </p>
        )}
      </div>
      <div className="pwa-install-banner__actions">
        {showAndroid && (
          <button type="button" className="pwa-install-banner__primary" onClick={handleInstall}>
            Install
          </button>
        )}
        {showIos && !showAndroid && (
          <button
            type="button"
            className="pwa-install-banner__primary"
            onClick={() => setShowIosHint(true)}
          >
            How to install
          </button>
        )}
        <button type="button" className="pwa-install-banner__secondary" onClick={dismiss}>
          Not now
        </button>
      </div>
    </div>
  );
}

export default PWAInstallPrompt;
